import { useState } from "react";
import LeftArrows from "../../assets/svg/LeftArrows.svg";
import RightArrows from "../../assets/svg/RightArrows.svg";

const MachineInfoCard = ({ activeMachine }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const handlePrev = () => {
    if (currentIndex > 0) setCurrentIndex((prevIndex) => prevIndex - 1);
  };

  const handleNext = () => {
    if (currentIndex + 1 < activeMachine?.length) setCurrentIndex((prevIndex) => prevIndex + 1);
  };

  return (
    <div className="bg-[#fff]">
      <div className="custom-container sm:pt-[63px] pt-[40px]">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-[46px]">
          <div className="col-span-3">
            <div class="grid grid-cols-8 gap-4">
              <div class="col-span-1 flex justify-start">
                <img src={LeftArrows} alt="" className="w-[100px] cursor-pointer	" onClick={handlePrev} />
              </div>
              <div class="col-span-6 max-h-[900px] w-[120%]">
                <img src={activeMachine?.[currentIndex]?.img} alt="" className="w-[120%]" />
              </div>
              <div class="col-span-1 flex justify-end	">
                <img src={RightArrows} alt="" className="w-[100px] cursor-pointer" onClick={handleNext} />
              </div>
            </div>

            <div class="grid lg:grid-cols-4 md:grid-cols-3 sm:lg:grid-cols-3 grid-cols-2 gap-4">
              <div className="bg-[#D9D9D9] md:w-auto sm:w-auto w-[100px] md:h-[225px] sm:h-[150px] h-[100px]" />
              <div className="bg-[#D9D9D9] md:w-auto sm:w-auto w-[100px] md:h-[225px] sm:h-[150px] h-[100px]" />
              <div className="bg-[#D9D9D9] md:w-auto sm:w-auto w-[100px] md:h-[225px] sm:h-[150px] h-[100px]" />
              <div className="bg-[#D9D9D9] md:w-auto sm:w-auto w-[100px] md:h-[225px] sm:h-[150px] h-[100px]" />
            </div>
          </div>
          <div className="col-span-2">
            <div className="font-[Roboto] 2xl:text-[35px] xl:text-[30px] lg:text-[25px] md:text-[20px] text-[17px] font-extrabold text-[#000]">
              {activeMachine?.[currentIndex]?.title}
            </div>
            <div className="font-[Roboto] font-normal 2xl:text-[30px] xl:text-[25px] lg:text-[23px] sm:text-[20px] text-[16px] text-[#000]">
              {activeMachine?.[currentIndex]?.subTitle}
            </div>

            <div className="mt-[46px]">
              <div className="font-[Roboto] font-bold 2xl:text-[30px] xl:text-[25px] lg:text-[23px] sm:text-[20px] text-[16px] text-[#000]">
                Key Features:
              </div>
              <ol className="list-disc ml-[40px]">
                <li className="font-[Roboto] font-normal 2xl:text-[30px] xl:text-[25px] lg:text-[23px] sm:text-[20px] text-[16px] text-[#000]">
                  Feature 1
                </li>
                <li className="font-[Roboto] font-normal 2xl:text-[30px] xl:text-[25px] lg:text-[23px] sm:text-[20px] text-[16px] text-[#000]">
                  Feature 2
                </li>
                <li className="font-[Roboto] font-normal 2xl:text-[30px] xl:text-[25px] lg:text-[23px] sm:text-[20px] text-[16px] text-[#000]">
                  Feature 3
                </li>
              </ol>
            </div>

            <div className="lg:mt-[50px] md:mt-[40px] mt-[30px]">
              <button
                className="rounded-lg bg-[#F2F2F2] border-[#5B792E] border-[4px] font-[Roboto] 2xl:text-[30px] xl:text-[25px] lg:text-[23px] sm:text-[20px] text-[16px] text-[#5B792E]  lg:py-[22px] md:py-[18px] sm:py-[15px] py-[10px] font-bold my-[10px] w-full"
                style={{ boxShadow: "0px 4px 4px 0px #00000040" }}
              >
                GET A QUOTE
              </button>
              {/* <button
                className="rounded-lg bg-[#7ABF5B] border-[#7ABF5B] border-[4px] font-[Roboto] 2xl:text-[30px] xl:text-[25px] lg:text-[23px] sm:text-[20px] text-[16px] text-[#fff]  lg:py-[22px] md:py-[18px] sm:py-[15px] py-[10px] font-bold my-[10px] w-full lg:mt-[30px] md:mt-[20px] mt-[10px]"
                style={{ boxShadow: "0px 4px 4px 0px #00000040" }}
              >
                FIND A DEALER
              </button> */}
            </div>

            <div className="lg:mt-[59px] md:mt-[40px] mt-[20px] md:mb-[100px] mb-[0px]">
              <a href="/assets/pdf/Tuatara-1000EFI-Spec-Sheet.pdf" target="_blank" rel="noopener noreferrer">
                <div className="font-[Roboto] font-bold 2xl:text-[30px] xl:text-[25px] lg:text-[23px] sm:text-[20px] text-[16px] text-[#000] cursor-pointer">{`View Spec Sheet >`}</div>
              </a>
              <div className="font-[Roboto] font-bold 2xl:text-[30px] xl:text-[25px] lg:text-[23px] sm:text-[20px] text-[16px] text-[#000] cursor-pointer mt-[27px]">{`View Operators Manual >`}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default MachineInfoCard;
